import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"

const Embed = ({ title, richContent, embed }) => {
  return (
    <section className="title-content-banner">
      <div className="title-content-banner__inner">
        <div className="title-content-banner__title" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
          {title && <h1>{parse(title)}</h1>}
          {richContent && <StructuredText data={richContent} />}
        </div>

        <div className="title-content-banner__image title-content-banner__emebd" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
          {embed && <div dangerouslySetInnerHTML={{ __html: embed }} />}
        </div>
      </div>
    </section>
  )
}

export default Embed

export const query = graphql`
  fragment EmbedProps on DatoCmsEmbed {
    ... on DatoCmsEmbed {
      id
      title
      richContent {
        value
      }
      embed
    }
  }
`
